import React, { Fragment, useEffect, useState } from "react";
import { Row, Col, Card, Badge, Button } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import DataTable from "react-data-table-component";
import { DELETE, GET, PATCH } from "../../../services/AxiosService";
import Dropdown from "react-bootstrap/Dropdown";
import Swal from "sweetalert2";
import DatePicker from "react-datepicker";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileCircleCheck, faCheckCircle, faClose } from "@fortawesome/free-solid-svg-icons";

const DaftarProvinsiKabupaten = () => {
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  //server side
  const [sortField, setSortField] = useState(null);
  const [sortOrder, setSortOrder] = useState(null);
  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [totalRows, setTotalRows] = useState(0);
  const [perPage, setPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState("");
  const [selectedPeriod, setSelectedPeriod] = useState("");
  const [selectedNamePeriod, setSelectedNamePeriod] = useState("");

  const [selectedTypeBuku, setSelectedTypeBuku] = useState("");
  const [selectedNameTypeBuku, setSelectedNameTypeBuku] = useState("");

  const [selectedStatusBuku, setSelectedStatusBuku] = useState("");
  const [selectedNameStatusBuku, setSelectedNameStatusBuku] = useState("");
  // validate
  const permissions = JSON.parse(localStorage.getItem('PROVINCE_PROVINCE') || '[]');
  const canModify = permissions.some(permission => ['CREATE', 'UPDATE', 'DELETE', 'LOCK', 'VIEW', 'APPROVE'].includes(permission));

  const fetchData = async (page, perPage, sortField, sortOrder, search) => {
    const params = {
      page,
      size: perPage,
      sort: sortField,
      orderby: sortOrder,
      search,
    };
    const res = await GET(`/province`, params);
    setData(res?.data);
    setTotalRows(res?.meta?.total);
  };

  const handleLockClick = async (id) => {
    Swal.fire({
      title: "Loading...",
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });

    const res = await PATCH(`province/lockUnlockProvince/${id}`);
    if (res) {
      Swal.fire({
        icon: "success",
        title: `Provinsi Non-Aktif!`,
      }).then(() => {
        Swal.close();
        fetchServerData(currentPage, perPage, sortField, sortOrder, searchTerm);
      });
    }
  };

  const handleLockOpenClick = async (id) => {
    Swal.fire({
      title: "Loading...",
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });

    const res = await PATCH(`province/lockUnlockProvince/${id}`);
    if (res) {
      Swal.fire({
        icon: "success",
        title: `Provinsi Aktif!`,
      }).then(() => {
        Swal.close();
        fetchServerData(currentPage, perPage, sortField, sortOrder, searchTerm);
      });
    }
  };

  const handleSelectTipeBuku = (e) => {
    setSelectedTypeBuku(e.target.getAttribute("value"));
    setSelectedNameTypeBuku(e.target.textContent);
  };

  const handleSelectStatusBuku = (e) => {
    setSelectedPeriod(e.target.getAttribute("value"));
    setSelectedNamePeriod(e.target.textContent);
  };

  const fetchServerData = () => {
    fetchData(currentPage, perPage, sortField, sortOrder, searchTerm, selectedPeriod, selectedTypeBuku);
  };

  useEffect(() => {
    fetchServerData();
  }, [perPage, searchTerm, currentPage, sortField, sortOrder, selectedTypeBuku, selectedStatusBuku, selectedPeriod]);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handlePerPageChange = (newPerPage) => {
    setPerPage(newPerPage);
    setResetPaginationToggle(!resetPaginationToggle);
  };

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
    setCurrentPage(1);
    // localStorage.setItem("searchTerm", e.target.value);
  };

  const handleSort = (column, direction) => {
    setSortField(column.field);
    setSortOrder(direction);
  };

  const columns = [
    {
      name: "Nama Provinsi",
      selector: (row) => row.name,
      sortable: true,
      field: "name",
    },
    {
      name: "Status",
      selector: (row) => row.status,
      //   width: "180px",
      cell: (row) => {
        let displayText;
        if (row.status === 1) {
          displayText = (
            <Badge as="a" variant="outline-success badge-rounded">
              Aktif
            </Badge>
          );
        } else if (row.status === 0) {
          displayText = (
            <Badge as="a" variant="outline-primary badge-rounded">
              Tidak Aktif
            </Badge>
          );
        } else {
          displayText = row.status;
        }
        return displayText;
      },
    },
    ...(canModify
      ? [{
        name: "Aksi",
        selector: (row) => row.id,
        width: "180px",
        cell: (row) => (
          <div>
            {permissions.includes('LOCK') && (
              <>
                {row.status === 1 ? (
                  <Link className="btn btn-danger shadow btn-xs sharp" onClick={() => handleLockClick(row.id)} title="Non-Aktif">
                    {/* <FontAwesomeIcon icon={faLock} /> */}
                    <i className="fa fa-lock"></i>
                  </Link>
                ) : (
                  <Link className="btn btn-success shadow btn-xs sharp" onClick={() => handleLockOpenClick(row.id)} title="Aktif">
                    {/* <FontAwesomeIcon icon={faLockOpen} /> */}
                    <i className="fa fa-unlock"></i>
                  </Link>
                )}{" "}
                &nbsp;
              </>
            )}

            {permissions.includes('UPDATE') && (
              <button className="btn btn-primary shadow btn-xs sharp" title="Edit" onClick={() => navigate(`/${row.id}/form-provinsi-kabupaten/Edit`)}>
                <i className="fa fa-pencil"></i>
              </button>
            )}
          </div>
        ),
      }]
      : [])
  ];

  const customStyles = {
    headRow: {
      style: {
        backgroundColor: "#FCFCFD",
        fontSize: "14px",
        fontWeight: "bold",
        color: "black",
      },
    },
    rows: {
      style: {
        backgroundColor: "#FFFFFF",
        "&:nth-child(2n)": {
          backgroundColor: "#F3F0FD",
        },
      },
    },
    cells: {
      style: {
        alignItems: "flex-start", // This will align content to the top
        paddingTop: "8px",
        paddingBottom: "8px",
        wordBreak: "normal",

      },
    },
  };

  return (
    <Fragment>
      <Row>
        <Col lg={12}>
          <Card>
            <Card.Header>
              <Card.Title>Provinsi</Card.Title>
            </Card.Header>
            <div className="d-flex justify-content-between mt-4">
              <div className="d-flex flex-wrap px-0">
                {/* <Dropdown className="mr-4">
                  <Dropdown.Toggle
                    style={{
                      background: "transparent",
                      borderColor: "grey",
                      color: "grey",
                      // borderRadius: "0",
                    }}
                    id="dropdown-basic"
                    width="200px"
                  >
                    {selectedTypeBuku?.length > 0 ? selectedNameTypeBuku : "Semua Tipe Buku"}
                  </Dropdown.Toggle>

                  <Dropdown.Menu>
                    <Dropdown.Item key="all" value="" onClick={handleSelectTipeBuku}>
                      Semua Buku
                    </Dropdown.Item>
                    {Array.isArray(typeBuku) &&
                      typeBuku.map((bukuType) => (
                        <Dropdown.Item key={bukuType.id} value={bukuType.name} onClick={handleSelectTipeBuku}>
                          {bukuType.name}
                        </Dropdown.Item>
                      ))}
                  </Dropdown.Menu>
                </Dropdown> */}
              </div>
              <div className="d-flex align-self-baseline px-4">
                {permissions.includes('CREATE') && (
                  <button className="btn btn-primary mr-2 same-height" onClick={() => navigate(`/form-provinsi-kabupaten/Tambah`)}>
                    Tambah Provinsi
                  </button>
                )}
                {/* <Button onClick={() => navigate(`/daftar-alokasi-pengeluaran-infaq`, { state: { from: "Tambah" } })}>Alokasi dan Pengeluaran Infaq</Button> */}
                <div className="input-group search-area d-xl-inline-flex">
                  <input type="text" className="form-control" placeholder="Cari Provinsi dan Kota" value={searchTerm} onChange={handleSearchChange} />
                  <div className="input-group-append">
                    <span className="input-group-text">
                      <Link to="#">
                        <i className="flaticon-381-search-2" />
                      </Link>
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <Card.Body>
              {data && data.length > 0 ? (
                <DataTable
                  columns={columns}
                  data={data}
                  customStyles={customStyles}
                  pagination
                  paginationServer
                  paginationRowsPerPageOptions={[10, 50, 100, 500]}
                  paginationResetDefaultPage={resetPaginationToggle}
                  paginationPerPage={perPage}
                  paginationTotalRows={totalRows}
                  onChangePage={handlePageChange}
                  onChangeRowsPerPage={handlePerPageChange}
                  onSort={handleSort}
                  defaultSortFieldId={1}
                  sortServer
                />
              ) : (
                <p>Tidak ada data</p>
              )}
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Fragment>
  );
};

export default DaftarProvinsiKabupaten;
